<template>
  <div class="active_audit_page">
   <img class="img_bg" :src="ainfo.enroll_success_pic?ainfo.enroll_success_pic:ainfo.background_pic" v-if="info.is_audit==0" />
   <img class="img_bg" :src="ainfo.audit_success_pic?ainfo.audit_success_pic:ainfo.background_pic" v-if="info.is_audit==1" />
   <img class="img_bg" :src="ainfo.audit_fail_pic?ainfo.audit_fail_pic:ainfo.background_pic" v-if="info.is_audit==2" />
   <div class="page_box">
    <div class="audit_title">{{ainfo.title}}</div>
    <div class="active_audit">
      <div class="point_line">
        <img class="active_state_img" :src="img.active_no" />
        <div class="line"></div>
        <img v-if="info.is_audit==0" class="active_state_img" :src="img.active_on" />
        <img v-if="info.is_audit==1" class="active_state_img" :src="img.active_no" />
        <img v-if="info.is_audit==2" class="active_state_img" :src="img.active_on" />
        <div class="line"></div>
        <img class="active_state_img" :src="info.is_audit==1?img.active_now:img.active_no" />
      </div>
      <div class="point_line_name">
        <div class="active_state_name">
          <div>
            申请中
          </div>
        </div>
        <div class="name_line"></div>
        <div class="active_state_name">
          <div class="active_state_name_on_r" v-if="info.is_audit==0">
            审核中
          </div>
          <div class="active_state_name" v-if="info.is_audit==1">
            审核
          </div>
          <div class="active_state_name_on_r" v-if="info.is_audit==2">
            审核未通过
          </div>
        </div>
        <div class="name_line"></div>
        <div :class="info.is_audit==1?'active_state_name active_state_name_on_g':'active_state_name'">
          <div>
            审核通过
          </div>
        </div>
      </div>
    </div>
    <div class="text-c audit_text" v-if="info.is_audit==0">您的基本信息已提交审核</div>
    <div class="text-c audit_text" v-if="info.is_audit==1">您的基本信息审核通过</div>
    <div class="audit_text" style="padding:0 60rpx;" v-if="info.is_audit==0||info.is_audit==1">
      <text>{{info.refuse_reason}}</text>
    </div>
    <div class="text-c audit_text" v-if="info.is_audit==2">您的基本信息未审核通过</div>
    <div class="text-c audit_text" style="padding:0 60rpx;" v-if="info.is_audit==2">
      未通过原因：
      <text>{{info.refuse_reason}}</text>
    </div>
    <div class="qrcode_img_box">
      <div class="qrcode_img_boxd">
        <div class="qrcode_top">
          <div>长按保存二维码</div>
          <div>随时查看审核进度</div>
        </div>

        <div class="qrcode_imgd">
          <img class="qrcode_img" :src="info.img">
        </div>
        <div style="font-size: 12px;margin-bottom: 10px;">长按保存二维码</div>
      </div>
    </div>
  </div>
      <!-- <div class="active_fixed_btn">
        <div class="fix_btn" v-if="info.left_button_name" @click="checkBtn()">{{info.left_button_name}}</div>
      </div> -->
    </div>
  </template>

  <script>
    import post from '../../../api/toyota/api';
    import { mapState } from 'vuex';
    import {Field,Uploader,Toast } from 'vant';
    export default {
      data () {
        return {
          hid:24,
          user_id:'',
          ainfo:'',
          info:'',
          imgcover_url:'',
          scene:0,
          img:{
            active_now: require('../../../assets/img/toyota/active/active_now.png'),
            active_on: require('../../../assets/img/toyota/active/active_on.png'),
            active_en: require('../../../assets/img/toyota/active/active_en.png'),
            active_no: require('../../../assets/img/toyota/active/active_no.png'),
          }
        }
      },
      watch: {
        '$route'(to, from) {
          if(this.scene != this.$route.query.scene) {
            if(this.$route.query.token!=this.token){
              this.user_id = this.$route.query.token
              this.getActiveAudit()
              this.getActiveInfo()
            }
            this.scene=new Date().getTime()
          }
        }
      },
      created () {
        if(this.scene != this.$route.query.scene) {
          if(this.$route.query.token!=this.token){
            this.token = this.$route.query.token
            this.getActiveAudit()
            this.getActiveInfo()
          }
          this.scene=new Date().getTime()
        }
      },
      methods: {
        getActiveInfo(){
          post.getActiveInfo({id:this.hid}).then(res => {
            if(res.data.state==1){
              this.ainfo=res.data.data
              document.title = res.data.data.title;
            } else {
              Toast(res.data.error[0]);
              return false
            }
          })
        },
        getActiveAudit(){
          post.getActiveAudit({
            token:this.token,
          }).then(res => {
            if(res.data.state==1){
              this.info = res.data.data.info
            }
          })
        },
      },
      components: {
        [Field.name]: Field,
        [Uploader.name]: Uploader,
        [Toast.name]:Toast 
      }
    };
  </script>

  <style lang="scss">
    .active_audit_page {
      height: 100vh;
      overflow-y: hidden;
      position:relative;
      .img_bg {
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
      }
      .page_box{
        position: absolute;
        width: 100%;
        z-index: 5;
        .audit_title{
          color: #AA0000;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-top: 10%;
          margin-bottom: 15px;
        }
        .active_audit{
         padding: 0 5px;
         padding-top: 10px;
         .point_line {
          display: flex;
          align-items: center;
          justify-content: center;
          .active_state_img {
            width: 15px;
            height: 15px;
          }
          .line{
            width: 100px;
            height: 1px;
            border-top: 1px solid #9A9A9A;
            margin: 0 8px;
          }
        }
        .point_line_name{
          display: flex;
          align-items: center;
          justify-content: center;
          color: #9A9A9A;
          font-size: 12px;
          margin-top: 10px;
          .active_state_name {
            min-width: 45px;
            text-align: center;
            color: #3a3a3a;
          }

          .active_state_name_on_g {
            color: #91C498;
            font-weight: bold;
          }

          .active_state_name_on_r {
            color: #EC8075;
            font-weight: bold;
          }

          .active_state_name_on_y {
            color: #9A9A9A;
            font-weight: bold;
          }
          .name_line {
            width: 70px;
            height: 1px;
            margin: 0 8px;
          }
        }
      }
      .audit_text{
        margin-top: 15px;
        color: #3a3a3a;
      // text-shadow: 2px 2px 5px #1E2A75;
      font-size: 15px;
      letter-spacing: 2px;
    }

  }

  .active_fixed_btn{
    width: 100%;
    position: fixed;
    bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
    .fix_btn{
      text-align: center;
      background-color: #AA0000;
      color: #fff;
      border-radius: 25px;
      font-size: 14px;
      padding: 12px 0;
      width: 150px;
    }
  }
  .qrcode_img_box{
    margin-top: 50px;
    display: flex;
    justify-content: center;

    .qrcode_img_boxd{
      width: 210px;
      
      text-align:center;
      border: 3px solid #AA0000;
      border-radius:5px;
      background-color:#FDF3F4;
    }
    .qrcode_top{
      color: #FFFFFF;
      font-size: 16px;
      text-align: center;
      padding: 15px 0;
      background-color: #B92433;
    }
    .qrcode_imgd{
     width: 180px;
     height: 180px;
     margin: 15px;
   }
   .qrcode_img{
    width: 180px;
    height: 180px;
  }
}
}
</style>
